<div class="container">
  <div class="add">
    <form [formGroup]="stateForm" (ngSubmit)="Submit($event)" class="post">
      <div class="post">
        <div class="form">
          <!-- <span class="input">
              <mat-form-field>
                  <mat-label>Payment Type</mat-label>
                  <mat-select formControlName="payment_mode" matNativeControl>
                    <mat-option value="Cash">Cash</mat-option>
                    <mat-option value="Credit">Credit</mat-option>
                    <mat-option value="Transfer">Transfer</mat-option>
                    <mat-option value="Cheque ">Cheque </mat-option>
                    <mat-option value="Dollar">Dollar</mat-option>
                  </mat-select>
                </mat-form-field>
          </span> -->
          <!-- <span class="input">
            <mat-form-field class="size">
                <mat-label>Payment Date</mat-label>
                <input formControlName="payment_date"  matInput [matDatepicker]="dob" required>
                <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                <mat-datepicker #dob></mat-datepicker>
              </mat-form-field>
        </span> -->
          <span class="input">
            <mat-form-field class="size">
              <mat-label>Refund Date</mat-label>
              <input
                formControlName="refund_date"
                matInput
                [matDatepicker]="ref"
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="ref"
              ></mat-datepicker-toggle>
              <mat-datepicker #ref></mat-datepicker>
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Refund Amount</mat-label>
              <input type="number" formControlName="refund_amount" matInput />
            </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
              <mat-label>Refund Resaon</mat-label>
              <input formControlName="refund_reason" matInput />
            </mat-form-field>
          </span>
        </div>
        <div class="but">
          <button
            style="float: left"
            type="submit"
            class="create"
            mat-raised-button
            color="primary"
          >
            {{ isLoading ? "Saving..." : "Save" }}
          </button>

          <!-- <button mat-raised-button color="primary" (click)="openIt()">
            Open modal
          </button> -->
        </div>
      </div>
    </form>
  </div>
</div>
